import webBackApi from '../../api/webBackApi';

const API_PATH = '/api/stock-chips';

// El backend envuelve cada chip como { id, data: {...} }; el resto del front
// trabaja con objetos planos, así que se desenvuelve acá, en el borde de la API.
const normalizeChip = (raw) => (raw && raw.data ? { id: raw.id, ...raw.data } : raw);

export const getStockChips = async () => {
  try {
    const response = await webBackApi.get(API_PATH);
    return response.data.map(normalizeChip);
  } catch (error) {
    console.error('Error fetching stock cams:', error);
    throw error;
  }
};

export const getStockChip = async (id) => {
  try {
    const response = await webBackApi.get(`${API_PATH}/${id}`);
    return normalizeChip(response.data);
  } catch (error) {
    console.error('Error fetching stock cam:', error);
    throw error;
  }
};

export const createStockChip = async (data) => {
  try {
    const response = await webBackApi.post(API_PATH, data);
    return normalizeChip(response.data);
  } catch (error) {
    console.error('Error creating stock cam:', error);
    throw error;
  }
};

// Update genérico: solo pisa los campos whitelisteados que mandes (associatedName,
// brand, phoneNumber, serialNumber, status, camIdentifier, customerId, assignedDate).
export const updateStockChip = async (id, data) => {
  try {
    const response = await webBackApi.put(`${API_PATH}/${id}`, data);
    return normalizeChip(response.data);
  } catch (error) {
    console.error('Error updating stock cam:', error);
    throw error;
  }
};

// Asigna camIdentifier/customerId a un chip; el server setea assignedDate.
export const assignStockChipCamara = async (id, { camIdentifier, customerId }) => {
  try {
    const response = await webBackApi.put(`${API_PATH}/${id}/camara`, {
      camIdentifier,
      customerId,
    });
    return normalizeChip(response.data);
  } catch (error) {
    console.error('Error assigning camara to stock chip:', error);
    throw error;
  }
};

// Limpia la asignación de cámara del chip (y el chipICCID de la cámara asociada).
export const clearStockChipCamara = async (id) => {
  try {
    const response = await webBackApi.delete(`${API_PATH}/${id}/camara`);
    return normalizeChip(response.data);
  } catch (error) {
    console.error('Error clearing camara from stock chip:', error);
    throw error;
  }
};

// El JWT (Bearer, igual que el resto de los endpoints) ya lo inyecta el
// interceptor de webBackApi — no hace falta X-API-KEY, eso es solo para
// integraciones server-to-server.
export const uploadStockChipsCsv = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await webBackApi.post(`${API_PATH}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading stock chips CSV:', error);
    throw error;
  }
};

export const deleteStockChip = async (id) => {
  try {
    await webBackApi.delete(`${API_PATH}/${id}`);
  } catch (error) {
    console.error('Error deleting stock cam:', error);
    throw error;
  }
};
